import { createHashRouter } from 'react-router-dom';
import Login from './pages/auth/Login';
import { ProtectedRoute } from './ProtectedRoute';
import Root from './Root'; 
import VerifyForgotEmail from './pages/auth/forgot-password/VerifyForgotEmail';
import NewPassword from './pages/auth/forgot-password/NewPassword';
import ForgotPassword from './pages/auth/forgot-password/ForgotPassword';
import PasswordResetSuccess from './pages/auth/forgot-password/PasswordResetSuccess';  
import DashboardMain from './pages/dashboard-main/DashboardMain'; 
import Signup from './pages/auth/signup/Signup';
import LandingList from './pages/landing/LandingList'; 
import LeaveMangementList from './pages/self-service/leave-application/LeaveMangementList';
import LeaveApprovalTable from './pages/self-service/leave-approval/LeaveApprovalTable';
import PayslipList from './pages/self-service/payslip/PayslipList';
import PasswordMngt from './pages/self-service/password-management/PasswordMngt';
import LoginOtp from './pages/auth/LoginOtp';
import ShiftRequestTable from './pages/self-service/shift-request/ShiftRequestTable';
 
export const router = createHashRouter([
	
	{
		path: '/',
		element: <Root />,
		children: [
			{
				path: '/',
				element: <Login />,
			},
			{
				path: '/login',
				element: <Login />,
			},
			{
				path:'/login-otp',
				element: <LoginOtp />,
			},
			{
				path:'/forgot-password',
				element: <ForgotPassword />,
			},
			{
				path:'/verify-forgot-email',
				element: <VerifyForgotEmail />,
			},
			{
				path:'/new-password',
				element: <NewPassword />,
			},
			{
				path:'/password-reset-success',
				element: <PasswordResetSuccess />,
			},
			{
				path:'/signup',
				element: <Signup />,
			},
			 
			
			  
			{
				element: <ProtectedRoute role={"EXECUTIVE"} />,
				children: [
					
					{
						path: '/dashboard-main',
						element: <DashboardMain />,
					},
					 

					{
						path:'/leave-applications-list',
						element: <LeaveMangementList />,
					},
					
					{
						path:'/leave-approvals',
						element: <LeaveApprovalTable />,
					},
					
					{
						path:'/payslip-reports',
						element: <PayslipList />,
					},
					{
						path:'/password-update',
						element: <PasswordMngt />,
					},
					{
						path:'/shift-request',
						element: <ShiftRequestTable />,
					},
					
					
					
				],
			},
			{
				path: '*',
				element: <p>404 - Error: Page not found</p>,
			},
		],
	},
]);
